// Shared between AddNewPopup (initial batch check) and FileLimitPopup (live
// recheck as the user trims files) so the two can't drift out of sync.

export const MAX_ROOM_ITEMS = 50;
export const FOLDER_LIMIT = 20;
export const ROOM_STORAGE_LIMIT_BYTES = 100 * 1024 * 1024;

export function getFolderPaths(files: File[]): string[] {
    const paths = new Set<string>();

    for (const file of files) {
        const relPath = file.webkitRelativePath;
        if (!relPath) continue;

        const parts = relPath.split("/");
        parts.pop();
        let current = "";
        for (const part of parts) {
            current = current ? `${current}/${part}` : part;
            paths.add(current);
        }
    }

    return Array.from(paths).sort(
        (a, b) => a.split("/").length - b.split("/").length
    );
}

export function hasExceededFolderDepth(files: File[]) {
    return files.some((file) => {
        const relPath = file.webkitRelativePath;
        if (!relPath) return false;

        const parts = relPath.split("/");
        parts.pop();

        return parts.length > 5;
    });
}
